import policyMedicinesCheckList from "./../kardex-dif-check-list/Kardex-difCheckList.vue";
import vademecum22 from "../../../services/asegurator/asegurator-medicine";
import XLSX from "xlsx";
import providerService from "../../../services/provider/ProviderService.js";
import locationService from "../../../services/location/LocationService.js";
import vademecum from "../../../services/vademecum/Vademecum.js";
import kardex from "../../../services/kardex/kardex-medicine.js";
import * as moment from "moment";

export default {
  components: {
    policyMedicinesCheckList,
  },
  data: () => ({
    search: "",
    headers: [
      {
        text: "Proveedor",
        sortable: true,
        value: "name_provider",
      },
      {
        text: "Farmacia",
        sortable: false,
        value: "name_branch",
      },
      {
        text: "Plu",
        sortable: true,
        value: "plu",
      },
      {
        text: "Medicamento",
        sortable: true,
        value: "name_medicine",
      },
      /*   {
                    text: "Cantidad entregada",
                    sortable: false,
                    value: "cantidad_entregada",
                },
                {
                    text: "Cantidad ingresada",
                    sortable: false,
                    value: "cantidad_ingresada",
                }, */
      {
        text: "Inventario",
        sortable: true,
        value: "inventario",
      },
    ],
    loading: false,
    pagination: {},
    searchType: "",
    provider: null,
    searchTypes: [
      { text: "Cadenas", value: "provider" },
      { text: "Farmacia", value: "branch" },
      { text: "Medicamento", value: "medicine" },
    ],
    itemsData: [],
    itemsDatatotal: [],
    itemsDataExcel: [],
    providers: [],
    branches: [],
    vademecumData: [],
    nroRows: 0,
    minDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
    date: "",
    date2: "",
    dataPicker2: false,
    dataPicker: false,
    totalrecords: 0
  }),
  watch: {
    pagination: {
      handler() {
        this.searchCity();
      },
      deep: true,
    },
    searchType(newValue, oldValue) {
      // Vaciar la variable search cuando cambie searchType
      this.search = "";
    },
  },
  created() {
    this.getProviders();
    this.getMedicines();
    //this.downloadexcel();
  },
  computed: {
    customHeaders() {
      return this.enabledColumns
        ? this.headers.filter((header) => this.enabledColumns[header.id])
        : this.headers;
    },
  },
  // mounted() {
  //     this.searchCity();
  // },
  methods: {
    async downloadexcel() {
      await kardex
        .getKardex(1, this.totalrecords, this.search, this.searchType)
        .then((response) => {
          this.itemsDatatotal = response.data[0];
        });
    },
    async exportToExcel() {
      await this.downloadexcel();
      const filteredData = this.itemsDatatotal.map((item) => ({
        Provedor: item.name_provider,
        Farmacia: item.name_branch,
        Plu: item.plu,
        Medicamento: item.name_medicine,
        "Cantidad entrega": item.cantidad_entregada,
        "Cantidad ingresada": item.cantidad_ingresada,
        Inventario: item.inventario,
      }));
      const worksheet = XLSX.utils.json_to_sheet(filteredData);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const date = new Date();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? "PM" : "AM";
      const formattedHours = hours % 12 || 12; // Convierte las 24 horas al formato de 12 horas

      // Formatea la hora en el formato HH-MM-AM/PM
      const formattedTime = `${formattedHours
        .toString()
        .padStart(2, "0")}:${minutes.toString().padStart(2, "0")} ${ampm}`;

      // Concatena la fecha y hora al nombre del archivo
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date
        .getDate()
        .toString()
        .padStart(2, "0")}_${formattedTime}`;

      const fileName = `Kardex_${formattedDate}.xlsx`;

      XLSX.writeFile(workbook, fileName);
    },
    async getProviders() {
      return await providerService.getProviders().then((response) => {
        this.providers = response.data;
      });
    },
    async Provider(providerId) {
      this.branches = [];
      return await locationService
        .getBranchesByProvider(providerId)
        .then((response) => {
          this.branches = response.data;
          if (this.branches && this.branches.code) {
            this.branches = [];
          }
        });
    },
    changeInitialDate() {
      let initialDate = moment(this.date).format("YYYY-MM-DD");
      this.minDate = initialDate;
      if (
        (this.date2 !== null) & (this.date2 !== undefined) &&
        this.date2 !== ""
      ) {
        if (!moment(this.date2).isSameOrAfter(initialDate)) {
          this.date2 = this.minDate;
        }
      }
    },
    getMedicines() {
      vademecum.getVademecumOrder().then((response) => {
        this.vademecumData = response.data;
        for (let index = 0; index < this.vademecumData.length; index++) {
          const medicinee = this.vademecumData[index];
          // if (medicinee.isApplicable || medicinee.isWatched) {
          //     this.vademecumData[index].disabled = true;
          // }
        }
        return this.vademecumData;
      });
    },
    onRowClick(item) {
      this.$emit("row-click", item);
    },
    searchCity() {
      this.loading = true;

      if (
        (this.searchType == "branch" ||
          this.searchType == "provider" ||
          this.searchType == "medicine") &&
        this.search == ""
      ) {
        this.loading = false;
        this.$notify({
          group: "app",
          type: "error",
          text: "No pueden quedar campos sin seleccionar",
        });
        return;
      } else {
        const { page, rowsPerPage } = this.pagination;
        kardex
          .getKardex(page, rowsPerPage, this.search, this.searchType)
          .then((response) => {
            this.loading = false;
            this.itemsData = response.data[0];
            this.nroRows = response.data[1];
            this.totalrecords = response.data[1];
          });
      }
      //this.downloadexcel();
    },
    // getLenght() {
    //     console.log(this.nroRows);
    //     return this.nroRows;
    // },
    customFilter(item, queryText, itemText) {
      const textOne = item.description.toLowerCase();
      const textTwo = item.plu.toLowerCase();
      const textThree = String(item.id).toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.includes(searchText) ||
        textTwo.includes(searchText) ||
        textThree.includes(searchText)
      );
    },
  },
};
